import type { Props } from "../../../types";
import { classNameParser } from "../../../helpers";

import "../../../styles/typography.css";
import "./style.css";
import { useState, type ReactElement } from "react";

type ProgressBarNodeProps = Props<{
  active?: boolean;
  isCurrent?: boolean;
  onClick: () => void;
}>;

type ProgressBarProps = Props<{
  title?: string;
  children: ReactElement<ProgressBarNodeProps>[];
}>;

export const ProgressBar = (props: ProgressBarProps) => {
  const [activeIndex, setActiveIndex] = useState<number>();

  return (
    <div className={classNameParser("flex justify-between", props.className)} style={props.style}>
      {props.title ? <h1 className="main-title-caption">{props.title}</h1> : null}
      <div className="flex items-center grow">
        {props.children.map((child, i) => {
          if (child.props.active && activeIndex === undefined) {
            setActiveIndex(i);
          }
          if (i > 0) {
            return (
              <div className="contents" key={i}>
                <div
                  className={`progress-bar--bar${
                    activeIndex !== undefined && i <= activeIndex ? " !bg-primary" : ""
                  }`}
                ></div>
                <ProgressBarNode {...child.props} active={activeIndex !== undefined && i <= activeIndex} />
                {/* {createElement(ProgressBarNode, {
                  ...child.props,
                  active: activeIndex !== undefined && i <= activeIndex,
                })} */}
              </div>
            );
          } else {
            return <ProgressBarNode {...child.props} active={activeIndex !== undefined && i <= activeIndex} key={i} />;
            // createElement(ProgressBarNode, {
            //   ...child.props,
            //   active: activeIndex !== undefined && i <= activeIndex,
            //   key: i,
            // });
          }
        })}
      </div>
    </div>
  );
};

export const ProgressBarNode = (props: ProgressBarNodeProps) =>
  props.isCurrent === true ? (
    <div className={`progress-bar--dot-max`}>
      <div className={`progress-bar--dot${props.active ? " !bg-primary !cursor-default" : ""}`}>
        <span className="progress-bar--label">{props.children}</span>
      </div>
    </div>
  ) : (
    <div className={`progress-bar--dot${props.active ? " !bg-primary" : ""}`} onClick={props.onClick}>
      <span className="progress-bar--label">{props.children}</span>
    </div>
  );
